import {Component, Prop, Vue, Watch} from 'vue-property-decorator'

import {Form, FormItem} from 'kpc/components/form'
import Button, {ButtonGroup} from 'kpc/components/button';
import Tooltip from 'kpc/components/tooltip';
import _ from "lodash";

import * as regionService from '../../../services/kec/region'
import {ConsoleCode} from "../../new-step-createKec/types";

const eventName = 'azChange'

interface IAz {
    azCode:string
    azName:string
    instanceCount:number
    isSoldOut:boolean
}

@Component({
    components: {
        Form, FormItem,
        Button, ButtonGroup,
        Tooltip
    }
})
export default class AzConfig extends Vue {


    @Prop({
        required: true
    })
    azList:IAz[] = []

    @Prop({
        required: true
    })
    az:string = ''

    @Prop({
        required: true
    })
    consoleCode:ConsoleCode = ConsoleCode.kec


    azCheck = ''

    regionService = regionService

    @Watch('az')
    azWatcher(val:string) {
        if (val !== this.azCheck) {
            this.azCheck = val
        }
    }

    @Watch('azCheck')
    azCheckWatcher() {
        if (this.azCheck !== this.az) {
            this.$emit(eventName, this.azCheck);
        }
    }

    goToKecList(azCode:string){
        let label = regionService.getAzLocaleTitleByCode(azCode);
        let search:any[] = []
        let searchInCache = sessionStorage.getItem('search');
        if (searchInCache) {
            try {
                search = JSON.parse(searchInCache)
            } catch(e) {}
        }

        let arr = _.filter(search,item => {
            return item.name !== 'az'
        });
        arr.push({
            name: "az",
            value: label,
            des: label,
            key: _.last(azCode)
        })
        sessionStorage.setItem('search',JSON.stringify(arr))
        setTimeout(() => {
            this.$router.push({
                name: 'ListView',
            });
        })
    }


}

